import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import { useParams } from 'react-router-dom';

const ChartOfAccountsInput = () => {
  const { chartOfAccountId = '' } = useParams();
  const decodedId = chartOfAccountId ? atob(chartOfAccountId) : chartOfAccountId;
  const id = decodedId.replace(/\D/g, ''); 
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [accountTypes, setAccountTypes] = useState([]);
  const route = 'chart_of_account';

  useEffect(() => {
    if (chartOfAccountId) {
      setIsEditing(true);
      fetchChartOfAccountsDetails();
    }
    fetchAccountTypes();
  }, [chartOfAccountId]);

  const fetchChartOfAccountsDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.chartOfAccounts}${id}/`, { headers });
      const chartOfAccountsDetails = response.data;

      setFormData(chartOfAccountsDetails);
    } catch (error) {
      console.error('Error fetching chart of accounts details:', error);
    }
  };

  const fetchAccountTypes = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.accountTypes}`, { headers });
      const accountTypes = response.data;

      const accountTypeOptions = accountTypes.map(accountType => ({
        value: accountType.id,
        label: accountType.name,
      }));

      setAccountTypes(accountTypeOptions);
    } catch (error) {
      console.error('Error fetching account types:', error);
    }
  };

  const handleFormSubmitSuccess = (response) => {
    // Handle form submission success
  };

  const chartOfAccountsFields = [
    {
      name: 'code',
      label: 'Account Code',
      type: 'text',
    },
    {
      name: 'name',
      label: 'Account Name',
      type: 'text',
    },
    {
      name: 'account_type',
      label: 'Account Type',
      type: 'select',
      options: [
        { value: 'ASSET', label: 'Asset' },
        { value: 'LIABILITY', label: 'Liability' },
        { value: 'EQUITY', label: 'Equity' },
        { value: 'REVENUE', label: 'Revenue' },
        { value: 'EXPENSE', label: 'Expense' },
      ],
    },
    {
      name: 'parent_account',
      label: 'Parent Account',
      type: 'select',
      options: accountTypes,
    },
    {
      name: 'balance',
      label: 'Balance',
      type: 'number',
    },
    {
      name: 'currency',
      label: 'Currency',
      type: 'select',
      options: [
        { value: 'USD', label: 'US Dollar' },
        { value: 'EUR', label: 'Euro' },
        { value: 'GBP', label: 'British Pound' },
        { value: 'KES', label: 'Kenyan Shilling' },
        { value: 'INR', label: 'Indian Rupee' },
        { value: 'JPY', label: 'Japanese Yen' },
      ],
    },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Chart of Accounts' : 'Create Chart of Accounts'}</h1>
      <FormComponent
        fields={chartOfAccountsFields}
        initialFormData={formData}
        route={route}
        onSubmitSuccess={handleFormSubmitSuccess}
        onSubmitError={() => {}}
      />
    </div>
  );
};

export default ChartOfAccountsInput;